// extracted by mini-css-extract-plugin
export default {"container":"RqutvHgYNvcwWu4DRSlM","col":"jhA_ziukYzdA2nMOCdyi"};